export default __webpack_public_path__ + "static/media/smiley_4.c2879c1b.svg";